import React, { Fragment } from 'react';
import { Lock, LogOut, User } from 'react-feather';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router';
import user from '../../../assets/images/user/user.png';
import { logOut } from '../../../utils/logOut';
// http://localhost:3000/apple-touch-icon.png
const UserMenu = ({ history }) => {

    const fullName = localStorage.getItem("fullName")
    const pwdTo = () => {
        history.push(`${process.env.PUBLIC_URL}/passwordreset`)
    }
    const handleLogOut = () => {
        logOut(() => history.push("/login")); // navigate fonksiyonunu callback olarak geçiyoruz
    };
    return (

        <Fragment>
            <li className="onhover-dropdown">
                <div className="media align-items-center">{/*
                    <img className="align-self-center pull-right img-50 rounded-circle blur-up lazyloaded" src={profile} alt="header-user" />
                */}
                    <div className="bg-light rounded-circle" style={{ width: "50px", height: "50px" }}>
                        <img className="align-self-center pull-right img-50 rounded-circle blur-up lazyloaded" src={user} alt="" />

                    </div>
                    <div className="dotted-animation">
                        <span className="animate-circle"></span>
                        <span className="main-circle"></span>
                    </div>
                </div>
                <ul className="profile-dropdown onhover-show-div p-20 profile-dropdown-hover" style={{ minWidth: "180px", minHeight: "110px" }} >
                    {/*
                    <li><Link to={`${process.env.PUBLIC_URL}/users/userEdit`}><User />Edit Profile</Link></li>
                    <li><a href="#!"><Mail />Inbox</a></li>
                    <li><a href="#!"><Lock />Lock Screen</a></li>
                    <li><a href="#!"><Settings />Settings</a></li>
                    */}
                    {localStorage.getItem("fullName") && <li><a href="#!" ><User />{fullName}</a></li>}
                    {//<li><a onClick={pwdToBildirim} href="#!" ><Lock/>Bildirimler</a></li>
                    }
                    <li><a onClick={pwdTo} href="#!" ><Lock /><FormattedMessage id={"sifremiDegistir"} /></a></li>

                    <li><a onClick={() => logOut(
                        () => history.push("/login"),
                        false
                    )} href="#!" ><LogOut /> <FormattedMessage id={"cikisYap"} /></a></li>
                </ul>
            </li>
        </Fragment>
    );
};


export default withRouter(UserMenu);